import { render, staticRenderFns } from "./CommonCreateFields.vue?vue&type=template&id=5e035224&"
import script from "./CommonCreateFields.vue?vue&type=script&lang=js&"
export * from "./CommonCreateFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports